import React from 'react'

const Steps = ({ active, mod }) => {
  const testArray = [1, 2, 3, 4]

  return (
    <div className={`steps ${mod || ''}`}>
      <ul className="steps_list">
        {testArray.map((item, index) => {
          const isActiveClass = index === active - 1 ? 'active_state' : ''

          return (
            <li className="steps_list_item" key={index}>
              <button className={`btn_step ${isActiveClass}`}>{item}</button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Steps
